export enum EDisplays {
    ASSETS_AND_LIABILITIES = 'ASSETS_AND_LIABILITIES',
    BASIC = 'BASIC',
    INCOME = 'INCOME',
    EXPENSE = 'EXPENSE',
    LOAN = 'LOAN',
    VEHICLE = 'VEHICLE',
    SELLER = 'SELLER',
    SERVICING_SUCCESS = 'SERVICING_SUCCESS',
    SERVICING_FAILURE = 'SERVICING_FAILURE',
    IDENTIFICATION = 'IDENTIFICATION',
    OCR_SUMMARY = 'OCR_SUMMARY',
    INDICATIVELY_APPROVED = 'APPROVED',
    INDICATIVELY_REFERRED = 'REFERRED',
    TEST_DRIVE_INDICATIVELY_REFERRED = 'TEST_DRIVE_REFERRED',
    INDICATIVELY_DECLINED = 'DECLINED',
    SUPPORTING_DOCS = 'SUPPORTING_DOCS',
    EMPLOYMENT = 'EMPLOYMENT',
    NONE = 'NONE',
    MANUAL_VEHICLE = 'MANUAL_VEHICLE',
    BUSINESS = 'BUSINESS',
    OCR_ANIMATION = 'OCR_ANIMATION',
    PREPPROVAL_ANIMATION = 'PREPPROVAL_ANIMATION',
    YOUR_SCORES = 'YOUR_SCORES',
    QUICK_CALCULATOR = 'QUICK_CALCULATOR',
    TEST_DRIVE_LANDING_PAGE = 'TEST_DRIVE_LANDING_PAGE',
    TRUCKSTOP_LANDING_PAGE = 'TRUCKSTOP_LANDING_PAGE',
    NO_LENDER_HOME = 'NO_LENDER_HOME',
    TEST_DRIVE_AGREEMENT = 'TEST_DRIVE_AGREEMENT',
    TEST_DRIVE_OCR_SUMMARY = 'TEST_DRIVE_OCR_SUMMARY',
    TEST_DRIVE_READY = 'TEST_DRIVE_READY',
    CAMPAIGN_LANDING = 'CAMPAIGN_LANDING',
    STORE_SELECTOR = 'STORE_SELECTOR',
    INELIGIBLE = 'INELIGIBLE',
    EMPLOYMENTINELIGIBLE = 'EMPLOYMENTINELIGIBLE',
    INCOMEINELIGIBLE = 'INCOMEINELIGIBLE',
    NOVATED_APPROVED = 'NOVATED_APPROVED',
}
